// extracted by mini-css-extract-plugin
module.exports = {"div":"Footer_div__5MpkX","div2":"Footer_div2__3XR7F","beian":"Footer_beian__17F-Q"};